import React from 'react';
import cx from 'classnames';
// components
import { LinkV2 } from '@zola/zola-ui/src/components/LinkV2';
import Stars from '@zola/zola-ui/src/assets/images/pre-auth/review-stars.svg';
import CardsSection from '../CardsSection';
import Card from '../Card';
// styles
import styles from './RegistryCardsSection.module.less';

const RegistryCardsSection: React.FC = (): JSX.Element => (
  <CardsSection>
    <Card
      className={styles.registryAdvisorContainer}
      title="Registry Advisor"
      dek="From sharing insider tips to picking out your dishes, our experts will help from start to
        finish."
      footer={
        <LinkV2 href="/advisor" className="card__footer" rel="noreferrer noopener" arrow>
          Learn More
        </LinkV2>
      }
    />
    <Card
      className={styles.reviewContainer}
      title={<img src={Stars} alt="review stars" />}
      dek={
        <span className={cx(styles.whiteText, styles.reviewText)}>
          “SO fun and easy to shop for gifts to put on our registry. If you’re getting married, Zola
          is an absolute must!”
        </span>
      }
      footer={
        <div className={styles.whiteText}>
          Alex & Sam<span className={styles.thinText}>, Denver, CO</span>
        </div>
      }
    />
  </CardsSection>
);

export default RegistryCardsSection;
